// "archived_merge" is the canonical archived type; "archived" is accepted as a
// tolerance since the contract's example payloads used it.
/** merge/details `type` values. */
export var MergeType = /*#__PURE__*/function (MergeType) {
  MergeType["Merge"] = "merge";
  MergeType["MultiMerge"] = "multi_merge";
  MergeType["MrnUpdate"] = "mrn_update";
  MergeType["ArchivedMerge"] = "archived_merge";
  return MergeType;
}({});
/** merge/details `status` values. */
export var MergeStatus = /*#__PURE__*/function (MergeStatus) {
  MergeStatus["Pending"] = "pending";
  MergeStatus["InProgress"] = "in_progress";
  MergeStatus["Failed"] = "failed";
  MergeStatus["Resolved"] = "resolved";
  return MergeStatus;
}({});

/* ---- merge/details response shapes ---- */

/** Custom-tag value type, drives how a tag value is rendered. */

/** A tag value as received from merge/details — shape depends on the tag type. */

/* ---- merge/confirm request shapes ---- */